import { useThree } from '@react-three/fiber';
import {debounce} from "../utils/debounce";
import * as logger from '../utils/logger';
import { useSceneReady } from './useSceneReady';

export const useScreenshot = (onReady) => {
  const { gl, scene, camera } = useThree();

  const debouncedTakeScreenshot = debounce((gl, scene, camera) => {
	  gl.render(scene, camera);
	  onReady(gl, scene, camera, gl.domElement.toDataURL());
  }, 100);

	useSceneReady(() => {
		logger.debug('[d8s renderer]: camera props before screenshot: ' , camera);
		debouncedTakeScreenshot(gl, scene, camera);
	});
};
